import { Building2, Handshake, BadgePercent, ArrowRight } from "lucide-react";
import { AGENCY_IMAGE } from "../assets";

const POINTS = [
  {
    icon: Handshake,
    title: "Tu partner operativo",
    text: "Tú mantienes la relación con el propietario. THE NEXT ROOM se ocupa del piso, de los inquilinos y de todo lo demás.",
  },
  {
    icon: BadgePercent,
    title: "Comisión por cada operación",
    text: "Acuerdo claro y alineado con resultados. Si cerramos contrato con tu cliente, tú cobras tu comisión.",
  },
  {
    icon: Building2,
    title: "Una alternativa de valor",
    text: "Ofrece a tus clientes una opción donde cobran puntual cada mes, sin riesgo de impago y sin costes de reforma.",
  },
];

export default function ForAgencies() {
  return (
    <section
      data-testid="agencies-section"
      className="nr-section nr-bg-soft"
    >
      <div className="nr-container grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <span className="nr-eyebrow">Para inmobiliarias</span>
          <h2 className="nr-h2 mt-4">
            Un partner serio para los clientes que no quieren más sobresaltos.
          </h2>
          <p className="mt-5 text-[16px] nr-text-soft max-w-[560px]">
            Colaboramos con agencias inmobiliarias que quieren ofrecer a sus
            clientes una solución de alquiler sin impagos, sin gestión y con
            cobro garantizado cada mes.
          </p>

          <div className="mt-10 space-y-6">
            {POINTS.map((p) => (
              <div key={p.title} className="flex gap-4">
                <div className="nr-service-icon !mb-0 !w-11 !h-11 !rounded-xl flex-shrink-0">
                  <p.icon size={20} />
                </div>
                <div>
                  <h3 className="nr-h3">{p.title}</h3>
                  <p className="mt-1.5 text-[14px] nr-text-soft leading-relaxed">
                    {p.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <a
            href="#contacto"
            data-testid="agencies-cta"
            className="nr-btn nr-btn-primary mt-10"
          >
            Hablemos de colaboración <ArrowRight size={16} />
          </a>
        </div>

        <div className="lg:col-span-6">
          <div className="rounded-3xl overflow-hidden border border-[#EAEAEA]">
            <img
              src={AGENCY_IMAGE}
              alt="Equipo profesional de inmobiliaria"
              className="w-full h-[520px] object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
